import React from 'react';

import { Skeleton } from '@material-ui/lab';

import Card from '../../../Card';
import Divider from '../../../Divider';

import { BreakUpCardSkeletonProps } from './BreakupCardSkeleton.types';

const BreakupCardSkeleton: React.FC<BreakUpCardSkeletonProps> = ({ className, size, showButton }) => {
  return (
    <Card className={`flex flex-column py4 ${className}`}>
      {Array(size)
        .fill(0)
        .map((_el, ind) => (
          <>
            <div className="flex flex-justify">
              <Skeleton
                variant="rect"
                key={ind}
                width={200}
                height={16}
                className={`mb6 mx3 br1 ${ind === size - 1 ? 'mb3' : ''}`}
              />
              <Skeleton
                variant="rect"
                height={16}
                width={24}
                className="mr2 mb2 br1"
              />
            </div>
            {ind === size - 1 && (
              <>
                {' '}
                <Divider className="mb3" />{' '}
                <div className="flex flex-justify">
                  <Skeleton
                    variant="rect"
                    height={16}
                    width={200}
                    className="mx3 br1"
                  />{' '}
                  <Skeleton
                    variant="rect"
                    height={16}
                    width={24}
                    className="mr2 mb2 br1"
                  />
                </div>
                { showButton &&
                <Skeleton variant='rect' width={1500} height={30} className="mx3 mt3"/>}
              </>
            )}
          </>
        ))}
    </Card>
  );
};

export default BreakupCardSkeleton;
export { BreakUpCardSkeletonProps };

